import { FiscalYearsState } from 'models';
import { FiscalYearsActionTypes } from './action-types';
import { Reducer } from 'redux';
import { ActionTypes } from 'store/helpers';

const initialState: FiscalYearsState = {
  fiscalYears: null,
  coopId: null,
};

export const reducer: Reducer<FiscalYearsState, ActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FiscalYearsActionTypes.SET_FISCAL_YEARS:
      return {
        fiscalYears: action.payload.res,
        coopId: action.payload.coopId,
      };
    default:
      return state;
  }
};
